import { MultiSectionLayout } from "@jugl-web/ui-components";
import { FC, ReactNode } from "react";
import { ReactComponent as AccentIcon } from "./assets/accent.svg";
import { ReactComponent as CloseIcon } from "./assets/close.svg";
import { ReactComponent as MessageIcon } from "./assets/message.svg";

export interface BrowserWindowShellProps {
  children: ReactNode;
  tabTitle: string;
  faviconSrc?: string | null;
  endSlot?: ReactNode;
}

export const BrowserWindowShell: FC<BrowserWindowShellProps> = ({
  faviconSrc,
  tabTitle,
  endSlot,
  children,
}) => (
  <MultiSectionLayout
    className="h-full w-full min-w-[400px] overflow-hidden rounded-[20px] border border-solid border-[#E0E0E0] bg-white shadow-[0_19px_50.2px_0_rgba(0,0,0,0.12)]"
    classNames={{
      content: "overflow-hidden",
    }}
    header={
      <div className="flex h-[53px] items-center justify-between gap-[15px] border-0 border-b border-solid border-[#F2F2F2] bg-grey-100 px-3 pr-4">
        <div className="flex items-center gap-[15px]">
          {/* macOS-style traffic-light buttons */}
          <div className="flex items-center gap-2">
            <div className="h-3 w-3 rounded-full bg-[#FA2C37]" />
            <div className="h-3 w-3 rounded-full bg-[#EFB100]" />
            <div className="h-3 w-3 rounded-full bg-[#00C851]" />
          </div>

          {/* Active browser tab */}
          <div className="relative mt-auto flex h-[46px] w-[320px] items-center justify-between gap-2 rounded-t-xl bg-white p-3 pr-2">
            <AccentIcon className="absolute bottom-0 left-0 -translate-x-full" />
            <AccentIcon className="absolute right-0 bottom-0 translate-x-full -scale-x-100" />
            <div className="flex items-center gap-2 overflow-hidden">
              {faviconSrc ? (
                <img
                  src={faviconSrc}
                  alt=""
                  className="h-4 w-4 shrink-0 rounded object-cover"
                />
              ) : (
                <MessageIcon className="shrink-0" />
              )}
              <span className="truncate font-secondary text-sm text-[#202124] select-none">
                {tabTitle}
              </span>
            </div>
            <CloseIcon className="shrink-0" />
          </div>
        </div>
        {endSlot !== undefined && (
          <div className="ml-auto shrink-0">{endSlot}</div>
        )}
      </div>
    }
  >
    {children}
  </MultiSectionLayout>
);
